module.exports = __webpack_public_path__ + "img/zhaohang2.b690020f.png";